<template>
	<div :style="shu.yangshi" class="zidingyi_kefu" >
		<img alt="" :src="shu.shu.tu"  v-if="shu.shu" :style="yangshi">
	</div>
</template>

<script>
	export default {
		name: 'anniu',
		data() {
			return {
				yangshi: ''
			}
		},
		props: {
			shu: {
				type: Object,
				default () {
					return {
						wenzi: '输入文字',
						yangshi: {}
					}
				}
			}
		},
		mounted() {
			if (!this.shu.shu) {
				this.$set(this.shu, 'shu', {
					tu: 'https://limitao.myuan.cn/gongyong/shangchuan/tu/16/2019/11/gXbEec5b155eT59PxCbBpp9m5rt5mJ.png',
					url: ''
				})
			}
			if (!this.shu.yangshi) {
				this.$set(this.shu, 'yangshi', {})
			}
		},
		watch: {
			'shu.yangshi.width':function(){
				this.Ys();
			},
			'shu.yangshi.height':function(){
				this.Ys();
			},
			'shu.yangshi.text_align':function(){
				this.Ys();
			},
		},
		methods:{
			Ys(){
				this.yangshi = "";
				var px='';
				if (this.shu.yangshi.width) {
					px=(this.shu.yangshi.width>0)?(this.shu.yangshi.width+'px'):this.shu.yangshi.width;					
					this.yangshi += "width:" +px+ ";";
				}
				if (this.shu.yangshi.height) {				
					px=(this.shu.yangshi.height>0)?(this.shu.yangshi.height+'px'):this.shu.yangshi.height;		
					this.yangshi += "height:" + px+ ";";
				}
				if (this.shu.yangshi.text_align) {
					this.yangshi += "text-align:" + this.shu.yangshi.text_align+ ";";
				}	
				console.log(this.yangshi)
			}
		}
	}
</script>
